<template>
    <router-view/>
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if(to.name == 'des-acerto-despesa'){
            next({ name: 'des-acerto-despesa-list' })
        }else{
            next()
        }
    },
    created() {
        if(this.$route.name == 'des-acerto-despesa'){
            this.$router.push({ name: 'des-acerto-despesa-list' })
        }
    }
}
</script>
